const primaryMain = '#4E3227';
const primaryMainOpacity = 'rgba(78, 50, 39, 0.9)';
const secondaryMain = '#FDDA24';
const secondaryMainOpacity = 'rgba(253, 218, 36, 0.5)';
const secondaryLight = '#FDDA24';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
